<template>
  <form
    ref="form"
    :data-url="`/technicalReviewer/recommendDecision/conclusions/${inputs.id}`"
    class="mb-0"
    :class="{ 'loading-opacity': preloader }"
  >
    <fieldset class="form-group">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Valoración global</label>
            <app-input
              type="textarea"
              v-model="inputs.observations_605"
              placeholder="Ingrese las observaciones"
              :required="true"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Satisfactoria</label>
            <app-input
              type="radio-buttons"
              v-model="inputs.is_satisfactory_605"
              :list="confirm"
            />
          </div>
        </div>

        <div class="col-12">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiURL";
export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
      confirm: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
  },

  created() {
    this.loadForm();
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      // this.$toastr.s(res.data.message);
      this.$store.state.evaluatorReview.evalTest = res.data.data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    data() {},

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest != null) {
        this.inputs = {
          id: this.$store.state.evaluatorReview.evalTest.id,
          observations_605: this.$store.state.evaluatorReview.evalTest
            .observations_605,
          is_satisfactory_605: this.$store.state.evaluatorReview.evalTest
            .is_satisfactory_605,
        };
      }
    },
  },
};
</script>
